import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recharge-info-block',
  templateUrl: './recharge-info-block.component.html',
  styleUrls: ['./recharge-info-block.component.scss']
})
export class RechargeInfoBlockComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
